/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTileFragment, TileFragment, FullTileFragment} from '@amblique/contentful/app/contentful/fragments/tile';

/**
 * Get a single Tile by ID (base - scalars only)
 */
export const getBaseTileById = gql`
  ${BaseTileFragment}

  query GetBaseTileById($id: String!, $locale: String!, $preview: Boolean) {
    tile(id: $id, locale: $locale, preview: $preview) {
      ...BaseTileFragment
    }
  }
`;

/**
 * Get a single Tile by ID (standard - 1 level deep)
 */
export const getTileById = gql`
  ${TileFragment}

  query GetTileById($id: String!, $locale: String!, $preview: Boolean) {
    tile(id: $id, locale: $locale, preview: $preview) {
      ...TileFragment
    }
  }
`;

/**
 * Get a single Tile by ID (full - 2 levels deep)
 */
export const getFullTileById = gql`
  ${FullTileFragment}

  query GetFullTileById($id: String!, $locale: String!, $preview: Boolean) {
    tile(id: $id, locale: $locale, preview: $preview) {
      ...FullTileFragment
    }
  }
`;

/**
 * Get all Tile entries with pagination (base - scalars only)
 */
export const getBaseTiles = gql`
  ${BaseTileFragment}

  query GetBaseTiles(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TileOrder]
    $where: TileFilter
    $preview: Boolean
  ) {
    tileCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseTileFragment
      }
    }
  }
`;

/**
 * Get all Tile entries with pagination (standard - 1 level deep)
 */
export const getTiles = gql`
  ${TileFragment}

  query GetTiles(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TileOrder]
    $where: TileFilter
    $preview: Boolean
  ) {
    tileCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...TileFragment
      }
    }
  }
`;

/**
 * Get all Tile entries with pagination (full - 2 levels deep)
 */
export const getFullTiles = gql`
  ${FullTileFragment}

  query GetFullTiles(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TileOrder]
    $where: TileFilter
    $preview: Boolean
  ) {
    tileCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullTileFragment
      }
    }
  }
`;
